import React from 'react'
import { PermisosUsuariosMainScreen } from './PermisosUsuariosMainScreen';
import { MenusScreen } from './Menus/MenusScreen';
import { ListadoConfiguraciones } from './ListadoConfiguraciones';
import { Route } from "react-router-dom";
import { PermisosUsuariosAgregarScreen } from './Usuarios/PermisosUsuariosAgregarScreen';
import PermisosUsuariosSeleccion from './Usuarios/PermisosUsuariosSeleccion';
import { EjemplosMenu1 } from './EjemplosMenu/EjemplosMenu1';
import { ConfNotificacionesMainScreen } from './Usuarios/Conf Notificaciones/ConfNotificacionesMainScreen';
import { CatalogoSalaScreen } from './GestioActividades/CatalogoSalas/CatalogoSalaScreen';
import { CatalogoGrupoActividadesScreen } from './GestioActividades/CatalogoGrupoAvtividades/CatalogoGrupoActividadesScreen';
import { CatalogoActividadesScreen } from './GestioActividades/CatalogoActividades/CatalogoActividadesScreen';
import { CatSalaResponsablesScreen } from './GestioActividades/CatalogoSalas/CatSalaResponsablesScreen';
import { CatSalaActividadesScreen } from './GestioActividades/CatalogoSalas/CatSalaActividadesScreen';
import { CatSalaCamposExtraScreen } from './GestioActividades/CatalogoSalas/CatSalaCamposExtraScreen';
import { CatActividadSubActividadesScreen } from './GestioActividades/CatalogoActividades/CatActividadSubActividadesScreen';
import { CatSeguimientoActividadesScreen } from './GestioActividades/CatalogoSeguimientoActividades/CatSeguimientoActividadesScreen'; 
import { SeguimientoActividadesAgregarScreen } from './GestioActividades/CatalogoSeguimientoActividades/SeguimientoActividadesAgregarScreen';
import { SeguimientoActividadesNuevaScreen } from './GestioActividades/CatalogoSeguimientoActividades/SeguimientoActividadesNuevaScreen';
import { SeguimientoActividadesCardScreen } from './GestioActividades/CatalogoSeguimientoActividades/SeguimientoActividadesCardScreen'; 
import { RedesSocialesMainScreen } from './RedesSociales/RedesSocialesMainScreen';
import { RSAñadirModal } from './RedesSociales/RSAñadirModal '
import { PresentacionesMainScreen } from './Presentaciones/PresentacionesMainScreen';
import { ConfigurarLeadsMainScreen } from './ConfigurarLeads/ConfigurarLeadsMainScreen';
import { CondonacionInteresMainScreen } from './CondonacionInteres/CondonacionInteresMainScreen';

export const ConfiguracionesMainScreen = () => { 
    return (
        <div className="main-container">
            <Route
                path="/Permisos/Main"
                component={() => <ListadoConfiguraciones />}
            />
            <Route
                path="/Permisos/PermisosUsuarios"
                component={() => <PermisosUsuariosMainScreen />}
            />
            <Route
                path="/Permisos/Menus"
                component={() => <MenusScreen />}
            />
            <Route
                path="/Permisos/Agregar"
                component={() => <PermisosUsuariosAgregarScreen />}
            />
            <Route
                path="/Permisos/UsuarioSeleccionado"
                component={() => <PermisosUsuariosSeleccion />}
            />
            <Route
                path="/Permisos/EjemplosMenu"
                component={() => <EjemplosMenu1 />}
            />
            <Route
                path="/Permisos/ConfigurarNotificaciones"
                component={() => <ConfNotificacionesMainScreen />}
            />
            <Route
                path="/Permisos/CatalogoSala"

                component={() => <CatalogoSalaScreen />}
            />
            <Route
                path="/Permisos/GrupoActividad"
                component={() => <CatalogoGrupoActividadesScreen />}
            />
             <Route
                path="/Permisos/Actividad"
                component={() => <CatalogoActividadesScreen />}
            />
            <Route
            path="/Permisos/CatSalaResponsables/:id"
            component={() => <CatSalaResponsablesScreen />}
            />
            <Route
            path="/Permisos/CatSalaActividades/:id"
            component={() => <CatSalaActividadesScreen />}
            />
            <Route
            path="/Permisos/CatSalaCamposExtra/:id"
            component={() => <CatSalaCamposExtraScreen />}
            />
            <Route
            path="/Permisos/CatActividadSubActividades/:id"
            component={() => <CatActividadSubActividadesScreen />}
            />
            <Route
            path="/Permisos/CatSeguimientoActividades"
            component={() => <CatSeguimientoActividadesScreen />}
            />
            <Route
            path="/Permisos/SeguimientoActividadesAgregar/:id?"
            component={() => <SeguimientoActividadesAgregarScreen />}
            />
            <Route
            path="/Permisos/SeguimientoActividadesNueva/:id?"
            component={() => <SeguimientoActividadesNuevaScreen />}
            />
            <Route
            path="/Permisos/SeguimientoActividadesCard/:id"
            component={() => <SeguimientoActividadesCardScreen />}
            />
            <Route
            path="/Permisos/RedesSocialesMain"
            component={() => <RedesSocialesMainScreen />}
            />
            <Route
            path="/Permisos/RSAñadir"
            component={() => <RSAñadirModal />}
            />
              <Route
            path="/Permisos/Presentaciones"
            component={() => <PresentacionesMainScreen />}
            />
            <Route
            path="/Permisos/ConfigurarLeads"
            component={() => <ConfigurarLeadsMainScreen />}
            />
            <Route
            path="/Permisos/ConfigurarCondonacionIntereses"
            component={() => <CondonacionInteresMainScreen />}
            />
        </div>
    );
};